import React from 'react';

/** Plain section — do not hide content while waiting for observers. */
export default function AnimatedSection({
  children,
  className = '',
  as: Tag = 'section',
  delay,
  ...rest
}) {
  return (
    <Tag className={className} {...rest}>
      {children}
    </Tag>
  );
}
